import Component from '@glimmer/component'
import { t } from 'ember-intl'
import { ReadAloudReviewModal } from 'teacher-ui-client/components/assignments-admin/read-aloud-review-modal'
import UiButton from 'teacher-ui-client/components/ui-button'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { task } from 'ember-concurrency'
import { tracked } from '@glimmer/tracking'
import { service } from '@ember/service'
import type Store from '@ember-data/store'
import { on } from '@ember/modifier'
import type Student from 'teacher-ui-client/models/student'
import UiButtonState from 'teacher-ui-client/components/ui-button/state'
import type Assignment from 'teacher-ui-client/models/assignment'
import type ReadAloudReview from 'teacher-ui-client/models/read-aloud-review'

interface Signature {
  Args: {
    assignmentId: string
    student: Student
    reviewId: Nullable<string>
    onSaved: () => void
  }
}

export class PlayAndReviewButton extends Component<Signature> {
  @tracked modalData?: { assignment: Assignment; review: ReadAloudReview }

  @service store!: Store

  openModal = task({ drop: true }, async () => {
    const [assignment, review] = await Promise.all([
      this.store.findRecord<Assignment>('assignment', this.args.assignmentId),
      this.args.reviewId
        ? this.store.findRecord<ReadAloudReview>('read-aloud-review', this.args.reviewId, {
            // @ts-expect-error - include types not correct
            include: 'student',
          })
        : this.store.createRecord<ReadAloudReview>('read-aloud-review', {
            assignmentUuid: this.args.assignmentId,
            student: this.args.student,
          }),
    ])
    this.modalData = { assignment, review }
  })

  onClickPlayAndReview = () => {
    void this.openModal.perform()
  }

  onCloseModal = () => {
    this.modalData = undefined
  }

  <template>
    <UiButton
      {{on "click" this.onClickPlayAndReview}}
      @appearance={{ButtonAppearance.muted}}
      class="whitespace-nowrap"
      @disabled={{this.openModal.isRunning}}
    >
      <UiButtonState @isLoading={{this.openModal.isRunning}}>
        {{t "reporting.playAndReview"}}
      </UiButtonState>
    </UiButton>
    {{#if this.modalData}}
      <ReadAloudReviewModal
        @assignment={{this.modalData.assignment}}
        @review={{this.modalData.review}}
        @close={{this.onCloseModal}}
        @onSaved={{@onSaved}}
      />
    {{/if}}
  </template>
}
